import { CaseStateMapper } from '@core/mapper/caseStateMapper';
import { Bad } from '@core/model/framework/Result/BadResult';
import { Ok } from '@core/model/framework/Result/OkResult';
import { Result } from '@core/model/framework/Result/Result';
import type { HttpClient } from '@core/model/framework/httpClient';
import {
  AccountService,
  GetCaseStateServiceInput,
  GetCaseStateServiceOutput,
} from '@core/model/service/accountService';
import { SERVICE_ID } from '@di/serviceId';
import { inject, injectable } from 'inversify';
import { GetCaseStateResponse } from './types/getCaseState';

@injectable()
export class DFAccountService implements AccountService {
  constructor(
    @inject(SERVICE_ID.openBankingHttpClient)
    private readonly httpClient: HttpClient,
    @inject(CaseStateMapper)
    private readonly caseStateMapper: CaseStateMapper
  ) {}
  async getCaseState(input: GetCaseStateServiceInput): GetCaseStateServiceOutput {
    const { userId, userToken } = input;

    const httpResult = await this.httpClient.get<GetCaseStateResponse>(
      `/users/${userId}/open-banking-case-clerk`,
      {
        Authorization: `Bearer ${userToken}`,
      }
    );

    const caseClerk = Result.unwrap(httpResult).data;

    if ('error' in caseClerk) {
      return Bad('GET_CASE_STATE_FAILED');
    }

    return Ok(this.caseStateMapper.toDomain(caseClerk.status));
  }
}
